import { render, staticRenderFns } from "./c-state-count-changes-chips.vue?vue&type=template&id=2b76ad82&"
import script from "./c-state-count-changes-chips.vue?vue&type=script&lang=js&"
export * from "./c-state-count-changes-chips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports